module.exports = __webpack_public_path__ + "pacifico.9b79bde19b07cbc80dae.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/other/pacifico.ttf
// module id = ../../../../../src/assets/fonts/other/pacifico.ttf
// module chunks = styles